// Tag chips row with Active toggle for TaskForm.
import { Box, Typography, Checkbox, FormControlLabel } from '@mui/material';
import TaskFormTagSection from '@/features/tasks/components/forms/fields/TaskFormTagSection';
import { useT } from '@/i18n/useT';

export function TaskFormTagRow({
  task,
  projectOptions,
  contextOptions,
  personOptions,
  parentTaskOptions,
  tasksMap,
  projectDisplayMap,
  contextDisplayMap,
  handleProjectsChange,
  handleContextsChange,
  handlePersonChange,
  handleParentChange,
  handleChange,
  titleInHeader,
}) {
  const t = useT();

  return (
    <Box sx={titleInHeader ? { mt: -0.25 } : undefined}>
      <Box
        sx={{
          display: 'flex',
          alignItems: 'flex-start',
          justifyContent: 'space-between',
          gap: 1,
          flexWrap: 'wrap',
        }}
      >
        <Box sx={{ flex: 1, minWidth: 0 }}>
          <TaskFormTagSection
            task={task}
            projectOptions={projectOptions}
            contextOptions={contextOptions}
            personOptions={personOptions}
            parentTaskOptions={parentTaskOptions}
            tasksMap={tasksMap}
            projectDisplayMap={projectDisplayMap}
            contextDisplayMap={contextDisplayMap}
            handleProjectsChange={handleProjectsChange}
            handleContextsChange={handleContextsChange}
            handlePersonChange={handlePersonChange}
            onParentChange={handleParentChange}
          />
        </Box>
        <FormControlLabel
          title={t(
            'taskform.backlogHint',
            'Staat niet in de actieve planning tot je de taak weer actief maakt.',
          )}
          sx={{ mr: 0, flexShrink: 0, alignSelf: 'flex-start' }}
          label={
            <Typography variant="caption" color="text.secondary">
              {t('taskform.backlog', 'Backlog')}
            </Typography>
          }
          control={
            <Checkbox
              size="small"
              checked={task.status === 'Backlog'}
              onChange={(e) => {
                const checked = e.target.checked;
                handleChange({
                  target: {
                    name: 'status',
                    value: checked ? 'Backlog' : 'Active',
                  },
                });
              }}
              sx={{ p: 0.5, '&.Mui-checked': { color: 'primary.main' } }}
            />
          }
        />
      </Box>
    </Box>
  );
}
